(() => {
  if (customElements.get('slider-products')) {
    return;
  }

  class sliderProducts extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('[data-section]');

      this.slider = null;
      this.options = {
        slidesPerView: 1.13,
        grabCursor: true,
        spaceBetween: 18,
        autoHeight: false,
        navigation: {
          prevEl: this.section.querySelector('[data-arrow-prev]'),
          nextEl: this.section.querySelector('[data-arrow-next]'),
        },
        breakpoints: {
          768: {
            slidesPerView: 2.2,
            spaceBetween: 18,
          },
          901: {
            slidesPerView: 2.6,
            spaceBetween: 24,
          },
          1201: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        },
      };
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      this.slider = new Swiper(this, this.options);
    }
  }

  customElements.define('slider-products', sliderProducts);
})();
